import React from 'react';
import { motion } from 'framer-motion';
import { ImagePlaceholder } from './ImagePlaceholder';
const milestones = [{
  week: 'SEMANA 1',
  title: 'El cuerpo empieza a escuchar',
  desc: 'La inflamación baja. La pesadez después de comer empieza a ceder. Dormís un poco mejor. Te levantás con menos rigidez. Es sutil, pero es real: algo está cambiando.',
  imgLabel: 'Mujer tomando la gomita con agua, sonriendo, ambiente de mañana',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/hMh4w2Ec5ZSXrwFhcKgkVt/heylloyd-image-1781539804308.png'
}, {
  week: '2 SEMANAS',
  title: 'La panza empieza a ceder',
  desc: 'El cortisol baja. El abdomen empieza a soltar. La ropa empieza a sentirse diferente. Los antojos de las 4 de la tarde? Desaparecen solos.',
  imgLabel: 'Before/after sutil — mismo jean, diferente contorno abdominal',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/eHtHaFNkyN4Huav4F6ceWa/heylloyd-image-1781538975236.png'
}, {
  week: '+4 SEMANAS',
  title: 'Te reconocés de nuevo',
  desc: 'No es solo el cuerpo. Es la energía. Es cómo te mirás al espejo. Es que volviste a sentirte liviana, segura, presente. Ya no dependés de la fuerza de voluntad. Tu cuerpo trabaja con vos.',
  imgLabel: 'Mujer 40+ sonriendo, ropa ajustada, postura abierta, confiada',
  imgSrc: 'https://cdn.magicpatterns.com/uploads/fHUwUAX3wbmfTBokMboCP3/heylloyd-image-1781539597039.png'
}];
export function Timeline() {
  return <section className="bg-esbelta-lavender/40 py-16 md:py-24 px-4 overflow-hidden" data-id="element-297">
      <div className="max-w-4xl mx-auto" data-id="element-298">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-center text-gray-900 mb-16" data-id="element-299">
          Hacé que volverte a sentir vos sea posible{' '}
          <span className="text-esbelta-violet" data-id="element-300">💜</span>
        </h2>

        <div className="relative" data-id="element-301">
          {/* Center Line Desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-esbelta-violet/20 -translate-x-1/2" data-id="element-302"></div>

          {/* Left Line Mobile */}
          <div className="md:hidden absolute left-6 top-0 bottom-0 w-0.5 bg-esbelta-violet/20" data-id="element-303"></div>

          <div className="space-y-12 md:space-y-24" data-id="element-304">
            {milestones.map((item, idx) => {
            const isEven = idx % 2 === 0;
            return <motion.div key={idx} initial={{
              opacity: 0,
              y: 50
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.6
            }} className={`relative flex flex-col md:flex-row gap-8 md:gap-16 items-center ${isEven ? '' : 'md:flex-row-reverse'}`} data-id="element-305">
                  {/* Dot */}
                  <div className="absolute left-6 md:left-1/2 w-4 h-4 rounded-full bg-esbelta-violet border-4 border-esbelta-lavender -translate-x-1/2 z-10 mt-6 md:mt-0 md:top-1/2 md:-translate-y-1/2" data-id="element-306"></div>

                  {/* Image */}
                  <div className="w-full md:w-1/2 pl-16 md:pl-0" data-id="element-307">
                    <div className="rounded-2xl overflow-hidden shadow-lg bg-esbelta-lavender/40" data-id="element-308">
                      {item.imgSrc ? <img src={item.imgSrc} alt={item.imgLabel} className="w-full h-auto object-contain" data-id="element-309" /> : <div className="aspect-[4/3]" data-id="element-310">
                          <ImagePlaceholder label={item.imgLabel} className="w-full h-full" data-id="element-311" />
                        </div>}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="w-full md:w-1/2 pl-16 md:pl-0" data-id="element-312">
                    <div className={`md:px-8 ${isEven ? 'md:text-left' : 'md:text-right'}`} data-id="element-313">
                      <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full bg-esbelta-lavender text-esbelta-violet font-bold text-xs tracking-wider mb-4 ${!isEven && 'md:ml-auto'}`} data-id="element-314">
                        <span data-id="element-315">💜</span> {item.week}
                      </div>
                      <h3 className="font-serif text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-316">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed text-lg" data-id="element-317">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}